import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'dateAgo',
	pure: true,
})
export class DateAgoPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		if (value) {
			const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
			if (seconds < 29)
				// less than 30 seconds ago will show as 'Just now'
				return 'Just now';
			const intervals = {
				year: 31536000,
				month: 2592000,
				week: 604800,
				day: 86400,
				hour: 3600,
				minute: 60,
				second: 1,
			};
			let counter = 0;
			for (const i in intervals) {
				switch (i) {
					case 'year': {
						counter = Math.floor(seconds / intervals.year);
						break;
					}
					case 'month': {
						counter = Math.floor(seconds / intervals.month);
						break;
					}
					case 'week': {
						counter = Math.floor(seconds / intervals.week);
						break;
					}
					case 'day': {
						counter = Math.floor(seconds / intervals.day);
						break;
					}
					case 'hour': {
						counter = Math.floor(seconds / intervals.hour);
						break;
					}
					case 'minute': {
						counter = Math.floor(seconds / intervals.minute);
						break;
					}
					case 'second': {
						counter = Math.floor(seconds / intervals.second);
						break;
					}
					default: {
						counter = 0;
						break;
					}
				}

				if (counter > 0) {
					if (counter === 1) {
						return counter + ' ' + i + ' ago'; // singular (1 day ago)
					} else {
						return counter + ' ' + i + 's ago'; // plural (2 days ago)
					}
				}
			}
		}
		return value;
	}
}
